import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import SafeIcon from '../common/SafeIcon';
import { FiArrowLeft, FiShare2 } from 'react-icons/fi';
import JobDetailContent from '../components/jobs/JobDetailContent';

const JobDetails = () => {
  const { id } = useParams();
  const { jobs, loading } = useAppContext();
  const [job, setJob] = useState(null);

  useEffect(() => {
    const foundJob = jobs.find(j => j.id === id);
    if (foundJob) setJob(foundJob);
  }, [id, jobs]);

  if (loading) return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-600"></div>
    </div>
  );

  if (!job) return (
    <div className="max-w-3xl mx-auto px-4 py-20 text-center">
      <h2 className="text-2xl font-bold text-stone-900 mb-4">Job not found</h2>
      <Link to="/" className="text-emerald-600 hover:underline">Back to all jobs</Link>
    </div>
  );

  return (
    <div className="bg-stone-50 min-h-screen py-8 sm:py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between mb-8">
          <Link to="/" className="inline-flex items-center text-stone-500 hover:text-emerald-600 font-medium transition-colors group">
            <SafeIcon icon={FiArrowLeft} className="mr-2 group-hover:-translate-x-1 transition-transform" /> Back to Jobs
          </Link>
          <button className="p-2 text-stone-400 hover:text-emerald-600 transition-all">
            <SafeIcon icon={FiShare2} className="text-xl" />
          </button>
        </div>

        <div className="bg-white rounded-3xl shadow-sm border border-stone-200 overflow-hidden">
          <JobDetailContent job={job} />
        </div>
      </div>
    </div>
  );
};

export default JobDetails;